import { Paper, Stack, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import PropTypes from "prop-types";

import { formatNumber } from "@/features/shared";
import { UpstreamTransactionLink } from "@/features/ui";

// The document total lives in Informasi Umum as Nilai, so it is deliberately
// not repeated under this grid.
export const OtherPaymentDetailsSection = ({ otherPaymentDetails }) => (
  <Paper sx={{ p: 2.5, borderRadius: 2 }}>
    <Stack spacing={2}>
      <Typography variant="h6">Rincian Pembayaran</Typography>

      <DataGrid
        rows={otherPaymentDetails}
        getRowId={(row) => row.id}
        getRowHeight={() => "auto"}
        columns={[
          {
            field: "code",
            headerName: "Akun",
            flex: 1,
            sortable: false,
            valueGetter: (_, row) => row.outletChartOfAccount?.code || "-",
          },
          {
            field: "name",
            headerName: "Nama Akun",
            flex: 2,
            sortable: false,
            valueGetter: (_, row) => row.outletChartOfAccount?.name || "-",
          },
          {
            field: "amount",
            headerName: "Nilai (Rp)",
            flex: 1.5,
            type: "number",
            sortable: false,
            valueFormatter: (value) => formatNumber(value),
          },
          {
            field: "sourceReferenceNumber",
            headerName: "Sumber",
            flex: 1.5,
            sortable: false,
            renderCell: ({ value, row }) =>
              value ? (
                <UpstreamTransactionLink
                  referenceNumber={value}
                  shortReference={false}
                />
              ) : (
                row.sourceLabel || "-"
              ),
          },
          {
            field: "note",
            headerName: "Catatan",
            flex: 2,
            sortable: false,
            valueGetter: (note) => note || "-",
          },
        ]}
        disableRowSelectionOnClick
        hideFooter
      />
    </Stack>
  </Paper>
);

OtherPaymentDetailsSection.propTypes = {
  otherPaymentDetails: PropTypes.arrayOf(PropTypes.object).isRequired,
};
